import { Component, Input } from '@angular/core';

@Component({
    selector: '[provascritta_entity_view]',
  templateUrl: 'provascritta-entity-view.component.html',
})

export class ProvaScrittaEntityViewComponent {
  @Input()
  element;
}
